import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ArchiveGuard } from 'src/app/guards/archive.guard';
import { ArchivesPage } from './archives';

const routes: Routes = [
  {
    path: 'choisir-un-titre',
    loadChildren: () => import('./archives-newspapers/archives-newspapers.module').then( m => m.ArchivesNewspapersModule)
  },
  {
    path: ':newspaper',
    loadChildren: () => import('./archives-list/archive-list.module').then( m => m.ArchiveListModule)
  },
  {
    path: '', canActivate: [ArchiveGuard], component: ArchivesPage
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ArchivesRoutingModule {}
